import { connect } from "react-redux";
var CurrentUser = require('lib/account/CurrentUser');
var AltModal = require("components/utility/AltModal");
var TextTypes = require('lib/academic/TextTypes');

var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");

var BookLogger = require("components/reading/books/BookLogger");
var SmartBookSearch = require("components/reading/books/SmartBookSearch");
var StudentsSelectedDisplay = require("components/org/roster/StudentsSelectedDisplay");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var ReadingActions = require("lib/actions/ReadingActions");

require("reading/books/log_reading_modal.scss");

@connect(
	(state, props) => ({
		asAdmin: CurrentUser.isAdmin(),
		totalStudents: RosterSelectors.students({ state }).length
	}),
	(dispatch, props) => {
		return {
			createLogs: (logs, queryParams) => {
				dispatch(ReadingActions.invalidateBookCache({}));
				return dispatch(ReadingActions.createLogs({ logs, query: queryParams }));
			},
		}
	}
)
class LogReadingModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		var books = [];
		if (props.initialBook) {
			books.push(props.initialBook);
		}

		this.state = { 
			existingBooks: null, books: books,
			loading: false, dailyMinuteMax: false
		};
	}

	onResetSearch() {
		this.setState({
			books: [] 
		});
	}

	onBookSelect(book) {
		var books = this.state.books.concat(book);
		var uniqBooks = _.uniq(books, function(book){ return book.title; });
		this.setState({ books: uniqBooks, showBookSearch: false });
	}

	removeBook(textTitle) {
		var newBooks = _.reject(this.state.books, function(book) {
			return book.title == textTitle
		});

		this.setState({ books: newBooks });
	}

	validate() {
		return _.all(this.state.books, function(book, i) {
			return this.refs["logger" + i].validate();
		}.bind(this));
	}

	submitReading() {
		this.setState({ loading: true })

		var emptyErrorsList = this.validate();

		if (emptyErrorsList) {
			var logList = [];
			for (var i = 0; i < this.state.books.length; i++) {
				var logData = this.refs["logger" + i].getData();
				var bookData = this.state.books[i];
				logData = _.map(logData, (log) => {
					if (bookData.text_id) {
						return _.extend({}, log, { text_id: bookData.text_id });
					} else {
						// Data to allow the server to create the copy of the book
						return _.extend({}, log, { text_data: bookData });
					}
				});

				logList = logList.concat(logData);
			}

			// If admin logging from roster page
			if (this.props.studentsSelected) {
				var studentIDs = _.pluck(this.props.studentsSelected, "id");
				var queryParams = { student_ids: studentIDs };

				if (this.props.studentsSelected.length > 1) {
					var successMessage = "Logs for your students have been saved."
				} else {
					var successMessage = "A log for your student has been saved."
				}			 	
			} else {
				var queryParams = {};
				var successMessage = "Good job logging your reading!"
			}
			
			this.props.createLogs(logList, queryParams).then((response) => {
				if (_.isEmpty(response.logs) && !this.props.asAdmin) {
					this.setState({ loading: false, dailyMinuteMax: true });

				} else {
					if (this.props.onClose) { this.props.onClose(true); }

					setTimeout(function() {
						window.wrNotifications.triggerDropDownNotification({
							title: "Reading Logged", text: successMessage, 
							icon: "ok-circle" 
						});
						CurrentUser.fetchCurrentUserCoinData();
						this.setState({ loading: false });
						setTimeout(() => {
							$(window.document).trigger("clear-selected-book")
						}, 100);
					}.bind(this), 100);
				}
			})

		} else {
			this.setState({ loading: false });
		}
	}

	goBack(e) {
		$wr.nope(e)
		this.props.onBack(this.props.bookStatus);
	}

	render() {
		var classAddOn = ""
		var bookLogs = this.state.books.map(function(book, i) {
			if (this.state.books.length > 1) {
				var removeBookF = this.removeBook.bind(this, book.title);
			}
			return (
				<BookLogger book={ book } ref={ "logger" + i } 
					key={ book.title } removeBook={ removeBookF } />
			);
		}.bind(this));

		if (this.state.books.length > 0) {
			var logReadingButton = (
				<LoadingButton className="btn buttonSuccess" loading={ this.state.loading }
					onClick={ this.submitReading } text="Log Reading!" />
			)
		}

		if (this.state.dailyMinuteMax) {
			var dailyMinuteMaxMessage = (
				<p className="dailyMinutesMaxErrorText">
					Wow, you read so much! You reached the limit of minutes you can log for one day.
				</p>
			)
		}
		if (this.props.studentsSelected) {
			var studentSelected = <StudentsSelectedDisplay totalStudents={ this.props.totalStudents }
							studentsSelected={ this.props.studentsSelected } />
			if (this.state.books.length) {
				var resetSearch = <a className="resetSearch" onClick={this.onResetSearch}>Change Book</a>
			} else {
				var searchBook = <SmartBookSearch onBookSelect={ this.onBookSelect } />
			}
			var classAddOn = "studentRosterModal "
		} else {
			var student = CurrentUser.get();
			// This is only for students
			var backLink = (
				<a href="#" className="backLink" onClick={ this.goBack }>
					<Glyphicon icon="arrow-left"/> Back
				</a>
			)
		}

		var className = "logReadingModal " + classAddOn;

		return (
			<AltModal className={ className } open={ this.props.open }
				headerText="Log Reading" onHide={ this.props.onClose }>

				{ studentSelected }
				{ searchBook }
				{ dailyMinuteMaxMessage }
				
				{ bookLogs }
				<div className="modalAction">
					{ logReadingButton }
					{ resetSearch }
				</div>
			</AltModal>
		)
	}

}

LogReadingModal.WrappedComponent.propTypes = StrictPropTypes({
	// Optionally, have a book to populate the books selected
	initialBook: PropTypes.object,
	studentsSelected: PropTypes.array,
	totalStudents: PropTypes.number,
	onBack: PropTypes.func,
	bookStatus: PropTypes.string,

	asAdmin: PropTypes.bool,

	onClose: PropTypes.func,
	open: PropTypes.bool,

	// handler from @connect
	createLogs: PropTypes.func
});


module.exports = LogReadingModal;


// WEBPACK FOOTER //
// ./modules/components/reading/books/LogReadingModal.js